import dayjs from 'dayjs';
import en from 'dayjs/locale/en' // load on demand
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.locale(en);
dayjs.extend(relativeTime);

export default dayjs